import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'wouter'
import { GraphQL } from '@guestgoodie/graphql'

import { helpers } from '@/features/goodies'
import Dropdown from '@/components/ui/Dropdown'
import { GoodieForm } from '@/features/goodies'
import { DialogHeader } from '@/layouts/Dialog'
import { useLingui } from '@lingui/react/macro'
import { Suspense } from '@/components/ui/Suspense'

export default function CreateGoodie() {
  const { t } = useLingui()
  const params = useParams() as { type: GraphQL.GoodieType }
  const goodieTypeOptions = helpers.useGoodieTypeOptions()

  const [type, setType] = useState<GraphQL.GoodieType>(
    params?.type ?? GraphQL.GoodieType.Default
  )

  const [, navigate] = useLocation()

  useEffect(() => {
    if (!params) return
    if (type !== params?.type) navigate(`/create-goodie/${type}`)
  }, [type, params, navigate])

  return (
    <div className="flex w-full flex-col p-5">
      <DialogHeader
        description={t`Creation of a new goodie`}
        title={t`Create Goodie`}
      >
        <span className="text-regular text-text">
          <Dropdown
            options={goodieTypeOptions}
            value={type}
            onChange={type => setType(type as GraphQL.GoodieType)}
          />
        </span>
      </DialogHeader>
      <Suspense>
        <GoodieForm type={type} />
      </Suspense>
    </div>
  )
}
